// 长期有效日期
export const LONG_EXPIRY_DATE = '2199-12-31'

/** 默认头像 */
export const DEFAULT_AVATAR = 'https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png'

/** antd 的 token 注入成 css var 时的变量名前缀 */
export const ANTD_CSS_VAR_PREFIX = '--ant-'

/** 盛付通项目 zf 号 */
export const ZF_NO = 'ZF2009'

/** 一小时的毫秒数 */
export const ONE_HOUR_MS = 60 * 60 * 1000
